import './assets/fonts.css';

import {
  StylesProvider,
  ThemeProvider,
  createGenerateClassName,
} from '@project44/material-ui-deprecated';

import { BrowserRouter } from 'react-router-dom';
import NavigationBar from 'components/NavigationBar';

const generateClassName = createGenerateClassName({
  productionPrefix: 'navigation-bar-ui',
});

export default function App() {
  return (
    <StylesProvider generateClassName={generateClassName}>
      <ThemeProvider>
        <BrowserRouter>
          <NavigationBar />
        </BrowserRouter>
      </ThemeProvider>
    </StylesProvider>
  );
}
